// extracted by mini-css-extract-plugin
export default {"microserviceIcon":"MicroserviceCommerce_microserviceIcon__DBk2a","glowBackground":"MicroserviceCommerce_glowBackground__OYG8a"};